<template>
  <div class="menu">
    <div v-if="props.isOpened" class="menu__overlay" @click="store.toggleHeaderMenu"></div>
    <div v-if="props.isOpened" class="menu__header">
      <img src="/src/assets/logos/mse-creditclub-logo.svg" alt="" aria-hidden="true" />
      <button class="menu__cross" aria-label="Toggle menu" @click="store.toggleHeaderMenu"></button>
    </div>
    <transition>
      <nav v-if="props.isOpened" class="menu__navigation">
        <NavigationList :routes="routes" @route-click="store.toggleHeaderMenu" @logout="logout" />
      </nav>
    </transition>
  </div>
</template>

<script setup lang="ts">
  import NavigationList from '@/components/header/components/NavigationList.vue';
  import { useStore } from '@/stores';
  import { NavigationLink } from '@/types/interfaces';

  const emit = defineEmits<{
    (n: 'logout'): void
  }>();

  const props = defineProps<{
    isOpened: boolean
    routes: NavigationLink[]
  }>();

  const store = useStore();

  const logout = () => {
    store.toggleHeaderMenu();
    emit('logout');
  };
</script>

<style scoped lang="scss">
  .menu {
    &__overlay {
      position: fixed;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      z-index: 14;
      background-color: $blue-rgb-60;
    }

    &__header {
      position: fixed;
      top: 0;
      left: 0;
      z-index: 16;
      display: grid;
      grid-template-columns: 80% 20%;
      align-items: center;
      width: 100%;
      height: 60px;
      padding: 0 16px;
      background: $light-navy-5;
      border-bottom: 1px solid $light-navy-40;
    }

    &__label {
      display: block;
      padding: 1px 4px 0;
      margin-left: 8px;
      font-size: remc(9px);
      font-weight: 600;
      line-height: remc(13px);
      color: $brand-primary-100-white;
      letter-spacing: 1px;
      background: $brand-primary-100-navy;
      border-radius: 2px;
    }

    &__title {
      display: flex;
      align-items: center;
      color: $brand-primary-100-navy;
    }

    &__cross {
      display: block;
      width: 24px;
      height: 24px;
      margin-left: auto;
      background-color: transparent;
      background-image: url('@/assets/icons/close-blue.svg');
      background-repeat: no-repeat;
    }

    &__navigation {
      position: fixed;
      top: 60px;
      left: 0;
      z-index: 15;
      width: 100%;
      height: 100%;
      padding-bottom: 60px;
      overflow: auto;
      background: $light-navy-5;
    }
  }

  .v-enter-active,
  .v-leave-active {
    transition: transform 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  }

  .v-enter-from,
  .v-leave-to {
    transform: translateX(-100%);
  }
</style>
